<template>
    <AuthenticatedLayout>

        <Toast position="top-center" />

        <div v-if="$page.props.auth.user.is_demo">
            <DemoBotWarning :current-date="currentDate"/>
        </div>

        <div class="flex flex-row w-full align-items-center justify-content-between mb-4 mt-4">
            <div class="flex flex-row align-items-center">
                <div class="text-4xl mr-3">Stats High-Low Level bot for {{pair.symbol}}</div>
                <div class="mr-4">
                    <a class="text-gray-400" :href="'https://ru.tradingview.com/chart/?symbol=BINANCE%3A'+pair.symbol" target="_blank"><i class="pi pi-external-link" style="font-size: 1.5rem"></i></a>
                </div>
                <div>

                </div>
            </div>
        </div>

        <div class="flex mb-4">
            <div class="flex-1">
                <Card>
                    <template #title>
                        Прибыльность за период в месяц
                    </template>
                    <template #content>
                        <DataTable :value="monthlyProfit" :paginator="true" :rows="15" responsiveLayout="scroll"
                                   paginatorTemplate="PageLinks"
                        >
                            <Column field="date" header="Месяц"></Column>
                            <Column header="Рынок"><template #body="{data}"><div v-html="round_colored(data.market_change, 0, '', '%')"></div></template></Column>
                            <Column header="Инвест"><template #body="{data}"><div v-html="round_colored(data.market_profit, 1)"></div></template></Column>
                            <Column header="HLL"><template #body="{data}"><div class="text-lg" v-html="round_colored(data.profit_hll, 1)"></div></template></Column>
                        </DataTable>
                    </template>
                </Card>
            </div>
            <div class="flex-1">

            </div>
        </div>

        <div class="flex">
            <div class="flex-1 flex flex-row">
                <div class="flex-1">
                    <Card>
                        <template #title>
                            Профит по типам
                        </template>
                        <template #content>
                            <div class="flex flex-column text-lg">
                                <div v-for="item in profitByType" class="mb-2 flex flex-row">
                                    <div class="w-8rem">{{item.type}}:</div>
                                    <div class="w-4rem" v-html="round_colored(item.profit, 2, )"></div>
                                    <div class="ml-3 text-gray-700">{{item.count}}</div>
                                </div>
                                <div class="flex flex-row text-2xl mt-4 mb-4">
                                    <div class="w-8rem">Итого PNL:</div><div v-html="round_colored(sumProfitsByType, 2)"></div>
                                    <div class="ml-2"></div>
                                </div>
                                <div class="flex flex-row">
                                    <div class="w-8rem">Рынок:</div>
                                    <div class="mr-2" v-html="round_colored(marketChangePercent, 0, '', '%')"></div>
                                    <div v-html="round_colored(marketProfit, 2, '($',')')"></div>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
                <div class="flex-1">
                    <Card class="ml-4" v-if="profitByType.length > 0">
                        <template #title>
                            Распределение профитов
                        </template>
                        <template #content>
                            <div class="flex flex-column mb-1">
                                <div v-for="item in profitByThreshold" class="mr-4 flex flex-row">
                                    <div class="w-7rem">{{item.title}}:</div>
                                    <div v-if="item.profit !== 0" class="w-3rem" v-html="round_colored(item.profit, 2, )"></div>
                                    <div v-if="item.profit !== 0" class="ml-1">({{item.count}})</div>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
                <div class="flex-1">
                    <Card class="ml-4">
                        <template #title>
                            Тюнинг
                        </template>
                        <template #content>
                            <div class="flex flex-row mb-1">
                                <div class="mr-4">
                                    <div class="mt-1 mb-1">hllWidth</div>
                                    <div v-for="(count, value) in tuningHllWidth" class="mr-4 flex flex-row">
                                        <div class="w-3rem">{{value}}:</div>
                                        <div class="ml-1">{{count}}</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="mt-1 mb-1">takeProfit</div>
                                    <div v-for="(count, value) in tuningTakeProfit" class="mr-4 flex flex-row">
                                        <div class="w-3rem">{{value}}:</div>
                                        <div class="ml-1">{{count}}</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="mt-1 mb-1">sellByTimeout</div>
                                    <div v-for="(count, value) in tuningSellByTimeout" class="mr-4 flex flex-row">
                                        <div class="w-3rem">{{value}}:</div>
                                        <div class="ml-1">{{count}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
            </div>

            <div class="flex-1 ml-4">

            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import DemoBotWarning from "@/Components/DemoBotWarning.vue";
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector.vue";
import DataTable from "primevue/datatable";
import Card from "primevue/card";
import Column from "primevue/column";
import helpers from "@/helpers";
import Toast from "primevue/toast";

export default {
    props:{
        currentDate: String,
        monthlyProfit: Array,
        pair: Object,
        hllWidthByPair: Object,
        takeProfitByPair: Object,
        profitByType: Array,
        profitByThreshold: Array,
        tuningHllWidth: Array,
        tuningTakeProfit: Array,
        tuningSellByTimeout: Array,
        marketChangePercent: Number,
        marketProfit: Number,
    },
    components:{
        Column, Card, DataTable,
        PairsTwoTableSelector,
        DemoBotWarning,
        AuthenticatedLayout, Toast
    },
    data(){
        return {

        }
    },
    methods:{
        ...helpers,
    },
    computed:{
        sumProfitsByType(){
            let sum = 0;
            this.profitByType.forEach((item) => {
                sum += parseFloat(item.profit);
            })
            return sum;
        }
    }
}
</script>

